import isFunction from 'lodash/isFunction';

const dynamicParameter = parameter => isFunction(parameter) ? self => parameter(self) : () => parameter;

export { dynamicParameter };
